import i18next from 'i18next';

import {
  GENERIC_MODAL_CANCEL_BUTTON,
  GENERIC_MODAL_SAVE_BUTTON,
} from '@commons/Modals/GenericModal/genericModalActions';

import CatalogPriceModalContent from '../components/CatalogPriceModalContent';

const MODAL_WIDTH = '560px';

export const getPriceModal = ({ price, onChangePrice, onCancel, onConfirm }) => {
  const parsedPrice = parseFloat(price);
  const isPriceInvalid = isNaN(parsedPrice) || parsedPrice < 0;

  return {
    type: 'action',
    width: MODAL_WIDTH,
    height: 'auto',
    icon: '/images/inpulse/edit-pen-black-small.svg',
    title: i18next.t('EXTERNAL_CLIENTS.CATALOG.PRICE_MODAL_TITLE'),
    component: CatalogPriceModalContent,
    data: { price, onChangePrice },
    handleCloseCleanUp: onCancel,
    actions: [
      {
        ...GENERIC_MODAL_CANCEL_BUTTON(),
        handleClick: onCancel,
      },
      {
        ...GENERIC_MODAL_SAVE_BUTTON(),
        isDisabled: isPriceInvalid,
        handleClick: onConfirm,
      },
    ],
  };
};
